import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OrderEntity } from './order.entity';

@Index(
	'order_note__fk_order__id__deleted_userId',
	['deletedUserId', 'fkOrderId'],
	{},
)
@Index('order_note__fk_order__id_fk', ['fkOrderId'], {})
@Entity('order_note')
export class OrderNoteEntity extends BaseEntity {
	@Column('text', { name: 'text' })
	public text!: string;

	@Column('varchar', { name: 'type', length: 255 })
	public type!: string;

	@Column('int', { name: '_fk_order__id', unsigned: true })
	public fkOrderId!: number;

	@ManyToOne(() => OrderEntity, (order) => order.orderNotes, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_order__id', referencedColumnName: 'id' }])
	public fkOrder!: OrderEntity;
}
